module.exports = __webpack_public_path__ + "static/media/product-off.676faf1a.png";